export const IconReevolLoader = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="232 296 380 308" {...props}>
        <polygon points="422.19 374.29 483.24 411.1 452.27 429.77 422.19 411.64 392.12 429.77 361.14 411.1 422.19 374.29" fill="#0D49E1">
            <animate attributeName="opacity" dur="1.0s" values="0;1;0" repeatCount="indefinite" begin="0.1" />
        </polygon>
        <polygon points="422.19 525.58 483.24 488.77 452.27 470.1 422.19 488.23 392.12 470.1 361.14 488.77 422.19 525.58" fill="#0D49E1">
            <animate attributeName="opacity" dur="1.0s" values="0;1;0" repeatCount="indefinite" begin="0.2" />
        </polygon>
        <g fill="#0D49E1">
            <polygon points="581.33 470.23 422.19 566.17 263.06 470.23 232.08 488.91 422.19 603.52 612.3 488.91 581.33 470.23" />
            <polygon points="327.59 468.67 358.56 450 294.03 411.1 294.03 411.09 422.19 333.83 550.35 411.09 550.35 411.1 485.82 450 516.8 468.68 612.3 411.1 422.19 296.48 232.08 411.1 327.59 468.67" />
            <polygon points="422.19 488.36 392.01 470.16 361.14 488.77 360.51 488.52 422.19 525.71 483.65 488.66 483.24 488.77 452.38 470.17 422.19 488.36" />
            <animate attributeName="opacity" dur="1.0s" values="0;1;0" repeatCount="indefinite" begin="0.3" />
        </g>
    </svg>
);
